export default "__VITE_ASSET__02a090ff__"